/**
 * True when this page load is the IdP redirect back to Studio after signing
 * in. Both WorkOS AuthKit and the OIDC client land on the origin with `code`
 * and `state`, and both strip them from the address bar right away, so a
 * refresh afterwards is an ordinary load.
 */
export function isSignInArrival(search: string): boolean {
  const params = new URLSearchParams(search);
  return Boolean(params.get('code')?.trim() && params.get('state')?.trim());
}

// Read at module load: the auth SDKs rewrite the URL as soon as they process
// the callback, before any component gets to look.
export const ARRIVED_FROM_SIGN_IN =
  typeof window !== 'undefined' && isSignInArrival(window.location.search);
